import React from 'react';
import OmAlert from '../../../../components/ui/OmAlert';

/**
 * ErrorDisplay Component
 * 
 * Displays error messages using OM Design System OmAlert component.
 * Replaces legacy HTML error divs with consistent OM styling.
 * 
 * @param {Object} props - Component props
 * @param {string} props.error - Error message to display
 * @param {string} [props.className] - Additional CSS classes
 */
const ErrorDisplay = ({ error, className = '' }) => {
  if (!error) {
    return null;
  }

  return (
    <OmAlert 
      alertType="error" 
      alertTitle="Error"
      message={error}
      className={`mb-4 ${className}`}
    />
  );
};

export default ErrorDisplay;